import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'copo-offline',
	templateUrl: './offline.component.html',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [MatIconModule, TranslateModule]
})
export class OfflineComponent {}
